import React from "react";
import { useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import AccessTime from "@mui/icons-material/AccessTime";
import { Path } from "../Path";
import { ConventionLogoSquare } from "./ConventionLogo";
import { formatConventionDateNoSubmission, formatLocation, formatSessionDate } from "@seabrookstudios/pitch2table-core";
import { useMyProfile } from "@seabrookstudios/pitch2table";

/**
 * Renders a session list entry.
 * @param {{ session: import("@seabrookstudios/pitch2table-core").Session }} props
 */
const SessionListEntry = ({ session }) => {
  const { data: profile } = useMyProfile();
  const navigate = useNavigate();

  const primary = session.type === "Pitching" ? "Pitching Session" : "Play Testing Session";
  const secondary = formatSessionDate(session.date, profile?.location?.timezone);

  const onClickHandler = () => {
    navigate(Path.session(session.id));
  };

  return (
    <ListItemButton alignItems="flex-start" selected={false} onClick={onClickHandler}>
      <ListItemAvatar>
        <Avatar>
          <AccessTime />
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={primary} secondary={secondary} />
    </ListItemButton>
  );
};

/**
 * Renders a convention (calendar event) list entry.
 * @param {{ event: import("@seabrookstudios/pitch2table-core").CalendarEvent }} props
 */
export const ConventionListEntry = ({ event }) => {
  const navigate = useNavigate();

  const primary = event.name;
  const secondary = `${formatConventionDateNoSubmission(event)} • ${formatLocation(event)}`;

  const onClickHandler = () => {
    navigate(Path.events().event(event.id));
  };

  return (
    <ListItemButton alignItems="flex-start" onClick={onClickHandler}>
      <ListItemAvatar>
        <ConventionLogoSquare convention={event} width={48} height={48} />
      </ListItemAvatar>
      <ListItemText primary={primary} secondary={secondary} />
    </ListItemButton>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ListItem} props.item
 */
export const ListEntry = ({ item }) => {
  if (item.type === "Session") {
    return <SessionListEntry session={item.data} />;
  }

  return <ConventionListEntry event={item.data} />;
};
